<div
  (click)="back()"
  class="d-flex gap-1 align-items-center back"
  style="cursor: pointer"
>
  <i class="fas fa-chevron-right"></i>
  <span>{{ "back-to-tickets" | translate }}</span>
</div>

<div class="custom-card">
  <p class="extra-info">{{ "extra information" | translate }}</p>
  <span class="extra-span">{{ "custom-form-info" | translate }}</span>
  <ng-container *ngIf="customFormDetails?.length">
    <div class="row justify-content-center my-4">
      <div class="col-12">
        <form [formGroup]="customForm">
          <div>
            <div>
              <ng-container formArrayName="values">
                <div
                  class="mb-4"
                  *ngFor="let control of valuesArray?.controls; let i = index"
                  [formGroupName]="i"
                >
                  <ng-container [ngSwitch]="customFormDetails[i]?.type">
                    <ng-container *ngSwitchCase="'radio'">
                      <label class="question"
                        >{{ customFormDetails[i]?.fieldName }}
                        <span
                          *ngIf="customFormDetails[i]?.validations.required"
                          style="color: red; font-size: large"
                          >*</span
                        ></label
                      >
                      <div
                        class="custom-control custom-radio"
                        *ngFor="
                          let radio of customFormDetails[i]?.options;
                          let k = index
                        "
                      >
                        <input
                          type="radio"
                          formControlName="value"
                          [value]="radio?.id"
                          [id]="['flexRadio' + radio?.id]"
                          class="custom-control-input"
                        />
                        <label
                          class="custom-control-label"
                          [for]="['flexRadio' + radio?.id]"
                        >
                          {{ radio.label }}
                        </label>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'select'">
                      <app-evento-select
                        [eventoFormControl]="control.get('value')"
                        [label]="customFormDetails[i]?.fieldName"
                        requiredMessage="{{ 'Required Field' | translate }}"
                        [items]="customFormDetails[i]?.options"
                        [hasStaticValues]="true"
                        [requiredQuestionFlag]="
                          customFormDetails[i]?.validations.required
                        "
                      >
                      </app-evento-select>
                    </ng-container>
                    <ng-container *ngSwitchCase="'text'">
                      <app-evento-input
                        [eventoFormControl]="control.get('value')"
                        [label]="customFormDetails[i]?.fieldName"
                        requiredMessage="{{ 'Required Field' | translate }}"
                        [requiredQuestionFlag]="
                          customFormDetails[i]?.validations.required
                        "
                        minlengthMessage="{{
                          'Min Length Field'
                            | translate
                              : {
                                  value:
                                    customFormDetails[i]?.validations.minLength
                                }
                        }}"
                        maxlengthMessage="{{
                          'Max Length Field'
                            | translate
                              : {
                                  value:
                                    customFormDetails[i]?.validations.maxLength
                                }
                        }}"
                        [placeholder]="
                          customFormDetails[i]?.description ||
                          customFormDetails[i]?.fieldName
                        "
                      ></app-evento-input>
                    </ng-container>
                    <ng-container *ngSwitchCase="'textarea'">
                      <app-evento-input
                        [eventoFormControl]="control.get('value')"
                        type="textarea"
                        [label]="customFormDetails[i]?.fieldName"
                        [requiredQuestionFlag]="
                          customFormDetails[i]?.validations.required
                        "
                        requiredMessage="{{ 'Required Field' | translate }}"
                        minlengthMessage="{{
                          'Min Length Field'
                            | translate
                              : {
                                  value:
                                    customFormDetails[i]?.validations.minLength
                                }
                        }}"
                        maxlengthMessage="{{
                          'Max Length Field'
                            | translate
                              : {
                                  value:
                                    customFormDetails[i]?.validations.maxLength
                                }
                        }}"
                        [placeholder]="
                          customFormDetails[i]?.description ||
                          customFormDetails[i]?.fieldName
                        "
                      ></app-evento-input>
                    </ng-container>
                    <ng-container *ngSwitchCase="'number'">
                      <app-evento-input
                        [eventoFormControl]="control.get('value')"
                        type="number"
                        [label]="customFormDetails[i]?.fieldName"
                        [requiredQuestionFlag]="
                          customFormDetails[i]?.validations.required
                        "
                        requiredMessage="{{ 'Required Field' | translate }}"
                        minMessage="{{
                          'Min Field'
                            | translate
                              : { value: customFormDetails[i]?.validations.min }
                        }}"
                        maxMessage="{{
                          'Max Field'
                            | translate
                              : { value: customFormDetails[i]?.validations.max }
                        }}"
                        [placeholder]="
                          customFormDetails[i]?.description ||
                          customFormDetails[i]?.fieldName
                        "
                      ></app-evento-input>
                    </ng-container>
                    <ng-container *ngSwitchCase="'date'">
                      <app-evento-input
                        [eventoFormControl]="control.get('value')"
                        [requiredQuestionFlag]="
                          customFormDetails[i]?.validations.required
                        "
                        type="datepicker"
                        requiredMessage="{{ 'Required Field' | translate }}"
                        minDateMessage="{{
                          'Min Date Field'
                            | translate
                              : {
                                  value:
                                    customFormDetails[
                                      i
                                    ].validations.minDate.split('T')[0]
                                }
                        }}"
                        maxDateMessage="{{
                          'Max Date Field'
                            | translate
                              : {
                                  value: helpers.formatDateForCustomValidators(
                                    customFormDetails[i]?.validations.maxDate
                                  )
                                }
                        }}"
                        [label]="customFormDetails[i]?.fieldName"
                        [placeholder]="
                          customFormDetails[i]?.description ||
                          customFormDetails[i]?.fieldName
                        "
                      ></app-evento-input>
                    </ng-container>
                    <ng-container *ngSwitchCase="'datetime'">
                      <app-evento-input
                        [requiredQuestionFlag]="
                          customFormDetails[i]?.validations.required
                        "
                        [eventoFormControl]="control.get('value')"
                        type="datetimepicker"
                        minDateMessage="{{
                          'Min Date Field'
                            | translate
                              : {
                                  value:
                                    customFormDetails[
                                      i
                                    ].validations.minDate.split('T')[0]
                                }
                        }}"
                        maxDateMessage="{{
                          'Max Date Field'
                            | translate
                              : {
                                  value: helpers.formatDateForCustomValidators(
                                    customFormDetails[i]?.validations.maxDate
                                  )
                                }
                        }}"
                        [label]="customFormDetails[i]?.fieldName"
                        [placeholder]="
                          customFormDetails[i]?.description ||
                          customFormDetails[i]?.fieldName
                        "
                      ></app-evento-input>
                    </ng-container>
                    <ng-container *ngSwitchCase="'checkbox'">
                      <label class="question"
                        >{{ customFormDetails[i]?.fieldName }}
                        <span
                          *ngIf="customFormDetails[i]?.validations.required"
                          style="color: red; font-size: large"
                          >*</span
                        ></label
                      >
                      <div
                        class="custom-control custom-checkbox"
                        *ngFor="
                          let checkbox of customFormDetails[i]?.options;
                          let k = index
                        "
                      >
                        <input
                          type="checkbox"
                          (change)="
                            fillCheckboxValues(control, $event, checkbox)
                          "
                          [id]="['flexCheckbox' + checkbox.id]"
                          class="custom-control-input"
                        />
                        <label
                          class="custom-control-label"
                          [for]="['flexCheckbox' + checkbox.id]"
                        >
                          {{ checkbox.label }}
                        </label>
                      </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'attachment'">
                      
                      <label class="question">
                        {{ customFormDetails[i]?.fieldName }}
                        <span
                          *ngIf="customFormDetails[i]?.validations.required"
                          style="color: red; font-size: large"
                          >*</span
                        >
                      </label>
                      <div class="custom-file-upload">
                        <input
                          type="file"
                          (change)="onFileSelected($event, control)"
                          [attr.multiple]="
                            customFormDetails[i]?.options?.multiple ? '' : null
                          "
                          [accept]="
                            customFormDetails[i]?.options?.acceptedTypes || '*'
                          "
                        />
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-container>
</div>
